import React from 'react';
import { Field } from 'react-final-form';
import cx from 'classnames';

// util
import * as Validations from 'components/common/form/commonValidations';

// form components
import { RenderDatePicker } from 'components/common/form/';
import { timezonesV2, startTimes } from 'components/common/form/timeValues';
import { FormDropdown } from 'components/common/form/FinalFormV2Elements';

import css from './MeetingTimeFormFieldSet.module.less';
import './DatePickerV2StyleOverrides.less';

// TODO: add component tests

const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

const MeetingTimeFormFieldSet = ({ disabled }) => (
  <div className={cx(css.timeFields, 'eventForm__timeFields')}>
    <Field
      name="date"
      validate={composeValidators(
        Validations.REQUIRED,
        Validations.DATE,
        Validations.DATE_AFTER_NOW
      )}
    >
      {datePickerProps => (
        <RenderDatePicker
          label="Date"
          className={cx(css.marginRight, 'datePickerV2StyleOverride')}
          autoComplete="off"
          datePickerOptions={{ disabledDays: { before: new Date() } }}
          calendarIcon
          input={datePickerProps.input}
          meta={datePickerProps.meta}
          disabled={disabled}
          placeholder="MM/DD/YYYY"
          useV2ErrorStyle
        />
      )}
    </Field>
    <FormDropdown
      className={css.marginRight}
      name="startTime"
      label="Start Time"
      validate={[Validations.REQUIRED]}
      options={startTimes}
      disabled={disabled}
    />
    <FormDropdown
      name="timezone"
      options={timezonesV2}
      label="Time Zone"
      validate={[Validations.REQUIRED]}
      disabled={disabled}
    />
  </div>
);

MeetingTimeFormFieldSet.propTypes = {};

MeetingTimeFormFieldSet.defaultProps = {
  initialValues: () => {},
};

export default MeetingTimeFormFieldSet;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/MeetingTimeFormFieldSet/MeetingTimeFormFieldSet.jsx